"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.render = void 0;
const vue_1 = require("vue");
const _withScopeId = n => ((0, vue_1.pushScopeId)("data-v-44994ba1"), n = n(), (0, vue_1.popScopeId)(), n);
const _hoisted_1 = { class: "home-flow home-view-box" };
const _hoisted_2 = { class: "home-flow-title" };
const _hoisted_3 = { class: "home-flow-menu" };
const _hoisted_4 = ["src"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_DetailTitle = (0, vue_1.resolveComponent)("DetailTitle");
    const _component_a_radio_button = (0, vue_1.resolveComponent)("a-radio-button");
    const _component_a_radio_group = (0, vue_1.resolveComponent)("a-radio-group");
    const _component_ListView = (0, vue_1.resolveComponent)("ListView");
    const _component_ComplexAutoModal = (0, vue_1.resolveComponent)("ComplexAutoModal");
    return ((0, vue_1.openBlock)(), (0, vue_1.createElementBlock)("div", _hoisted_1, [
        (0, vue_1.createElementVNode)("div", _hoisted_2, [
            (0, vue_1.createVNode)(_component_DetailTitle, { title: "流程待办" })
        ]),
        (0, vue_1.createElementVNode)("div", _hoisted_3, [
            (0, vue_1.createVNode)(_component_a_radio_group, {
                value: _ctx.mainData.type.status,
                "onUpdate:value": _cache[0] || (_cache[0] = ($event) => ((_ctx.mainData.type.status) = $event))
            }, {
                default: (0, vue_1.withCtx)(() => [
                    ((0, vue_1.openBlock)(true), (0, vue_1.createElementBlock)(vue_1.Fragment, null, (0, vue_1.renderList)(_ctx.mainData.type.list, (val, index) => {
                        return ((0, vue_1.openBlock)(), (0, vue_1.createBlock)(_component_a_radio_button, {
                            key: index,
                            value: val.value
                        }, {
                            default: (0, vue_1.withCtx)(() => [
                                (0, vue_1.createTextVNode)((0, vue_1.toDisplayString)(val.name), 1)
                            ]),
                            _: 2
                        }, 1032, ["value"]));
                    }), 128))
                ]),
                _: 1
            }, 8, ["value"])
        ]),
        (0, vue_1.createVNode)(_component_ListView, {
            ref: "list-view",
            "complex-list": _ctx.mainData,
            option: _ctx.listOption,
            onMenu: _ctx.onMenu
        }, null, 8, ["complex-list", "option", "onMenu"]),
        (0, vue_1.createVNode)(_component_ComplexAutoModal, {
            menuType: {
                type: 'default',
                name: '关闭'
            },
            optionProps: {
                width: 960,
                destroyOnClose: true
            },
            ref: "iframe-modal"
        }, {
            default: (0, vue_1.withCtx)(() => [
                (0, vue_1.createElementVNode)("div", null, [
                    (0, vue_1.createElementVNode)("iframe", {
                        ref: "iframe",
                        src: _ctx.iframe.url,
                        frameborder: "0",
                        width: "100%",
                        height: "800px",
                        scrolling: "auto"
                    }, null, 8, _hoisted_4)
                ])
            ]),
            _: 1
        }, 512)
    ]));
}
exports.render = render;
